import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./root/App";
import { ProductAnalyticsProvider } from "./analytics/ProductAnalyticsProvider";

const mountEl = document.getElementById("mount");

if (mountEl) {
  createRoot(mountEl).render(
    React.createElement(ProductAnalyticsProvider, null, React.createElement(App, null)),
  );
}
